module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-info-block",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "valor-debitado"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "valor-debitado-titulo"
  }, [_vm._v("Informe o valor debitado na fatura do cartão " + _vm._s(_vm.numeroCartao))]), _vm._v(" "), _c('p', [_vm._v("Valor Debitado: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.valorDebitado),
      expression: "valorDebitado",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-one-real",
      rawName: "v-mask-one-real"
    }],
    attrs: {
      "type": "text",
      "placeholder": " valor debitado"
    },
    domProps: {
      "value": (_vm.valorDebitado)
    },
    on: {
      "change": function($event) {
        _vm.valorDebitado = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer buttons-container"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Agora não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.confirmCard()
      }
    }
  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-info-block",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "contrato-ativado"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', {
    staticClass: "valor-debitado-titulo"
  }, [_vm._v("Parabéns! Você conseguiu ativar o cartão " + _vm._s(_vm.numeroCartao) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [
    [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      }
    }, [_vm._v("OK")])]
  ], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-info-block",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "erro-debito"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/exclamation-mark.svg"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.erroDebito == 1) ? _c('h4', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.msgErro))]) : _vm._e(), _vm._v(" "), (_vm.erroDebito == 2) ? _c('h4', {
    staticClass: "text-danger"
  }, [_vm._v("Valor informado incorreto, gerando descontinuidade no seu cadastro.")]) : _vm._e(), _vm._v(" "), (_vm.erroDebito == 2) ? _c('h4', {
    staticClass: "text-danger"
  }, [_vm._v("Favor realizar o cadastro novamente. O valor descontado será estornado na sua fatura.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [
    [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.confirmaErro()
        }
      }
    }, [_vm._v("OK")])]
  ], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 plan-desk"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-plans"
  }, [_vm._v("Planos")]), _vm._v(" "), (_vm.state == 'LOADED') ? _c('div', [_c('router-link', {
    staticClass: "btn btn-primary btn-new-plan",
    class: {
      'disabled': !_vm.checkVehicle
    },
    attrs: {
      "tag": "button",
      "to": {
        name: 'new-contract'
      },
      "disabled": !_vm.checkVehicle || _vm.bloqueiaRoadcard
    }
  }, [_c('i', {
    staticClass: "icon-plus icon-plus-plan align-icon-right-sm"
  }), _vm._v(" "), _c('span', [_vm._v("Novo Plano")])]), _vm._v(" "), _c('button', {
    staticClass: "btn-merc",
    on: {
      "click": function($event) {
        return _vm.openMyContractsModal()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 min-content"
  }, [(_vm.state == 'LOADING') ? void 0 : _vm._e(), _vm._v(" "), (_vm.state == 'ERROR') ? [_c('div', {
    staticClass: "error-block"
  }, [_vm._v("Houve um erro carregando os contratos. Por favor, aguarde e tente novamente. ")])] : _vm._e(), _vm._v(" "), (_vm.vp) ? _c('accordion', {
    staticClass: "margin-t20 vp-accordion",
    attrs: {
      "open": true
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('span', {
    staticClass: "upper bold"
  }, [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-striped table-vp"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Emissor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Valor VP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vp), function(v, index) {
    return _c('tr', {
      key: index,
      class: {
        red: v.idProtocoloCanc != null
      }
    }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.embarcador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-center"
    }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))])] : _vm._e()], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex action-buttons margin-t10"
  }, [_c('router-link', {
    staticClass: "btn-act",
    attrs: {
      "to": {
        name: 'my-toll-ticket',
        params: {
          contractId: _vm.vp[0].contratoDest,
          planId: 7
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\r\n                          Ver Todos Vales-pedágio\r\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-act",
    attrs: {
      "to": {
        name: 'statement-consolidated',
        params: {
          contractId: _vm.vp[0].contratoDest
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\r\n                          Saldo & Extrato\r\n                        ")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.contracts), function(c, n) {
    return (_vm.state == 'LOADED' && c.plan.planId != 7) ? [((c.plan.planId == 21 || c.plan.planId == 22 || c.plan.planId == 35 || c.plan.planId == 36) && _vm.checkVehicle) ? _c('modal-transfer', {
      key: n
    }) : _vm._e(), _vm._v(" "), (c.plan.planId == 45 || c.plan.planId == 46) ? _c('accordion', {
      key: n,
      staticClass: "margin-t20 vp-accordion aggregate-acc",
      attrs: {
        "open": true
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('contract-name', {
      attrs: {
        "contractId": c.contractId,
        "planId": c.plan.planId,
        "contractName": c.name,
        "currentBalance": c.currentBalance.currentTotalBalance
      },
      model: {
        value: (c.name),
        callback: function($$v) {
          _vm.$set(c, "name", $$v)
        },
        expression: "c.name"
      }
    })], 1), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "vp-card-box"
    }, [_c('div', {
      staticClass: "vp-card-info"
    }, [_c('small', [_vm._v("Saldo")]), _vm._v(" "), _c('p', {
      staticClass: "no-margin green"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-redeem-balance",
      attrs: {
        "to": {
          name: 'rescue-balance',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-rescue"
    }), _vm._v("\r\n                            Resgatar saldo\r\n                          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-new-vp",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modalTollTicket()
        }
      }
    }, [_c('i', {
      staticClass: "icon-plus ie"
    }), _vm._v("\r\n                            Novo VP\r\n                          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-new-aggregate",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modalAggregate(c)
        }
      }
    }, [_c('i', {
      staticClass: "icon-plus ie"
    }), _vm._v("\r\n                            Novo Agregador\r\n                          ")])], 1), _vm._v(" "), (!_vm.loadingVehiclesAggregate && _vm.aggregateVehicles) ? _c('table', {
      staticClass: "table table-striped table-vp"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "15%"
      }
    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "35%"
      }
    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Último VP")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Última passagem")]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Saldo VP")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "7%"
      }
    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.aggregateVehicles), function(v, index) {
      return _c('tr', {
        key: index,
        class: {
          red: v.idProtocoloCanc != null
        }
      }, [(index < 6) ? [_c('td', {
        staticClass: "text-center bold td-plate"
      }, [_c('span', [_vm._v(_vm._s(v.plate))]), _vm._v(" "), _c('span', {
        staticClass: "hide"
      }, [_vm._v(_vm._s(v.contractIdAgr))]), _vm._v(" "), _c('span', {
        staticClass: "hide"
      }, [_vm._v(_vm._s(v.contractIdVp))])]), _vm._v(" "), _c('td', {
        staticClass: "ico-info text-center"
      }, [(v.reason == 'Desbloqueado') ? _c('i', {
        staticClass: "icomoon-truck-ok text-center"
      }) : (v.reason == 'Temporariamente') ? _c('i', {
        staticClass: "icomoon-truck-block text-center"
      }) : [_vm._v(_vm._s(v.reason))]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.transportador))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.lastVp)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.lastPassage)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("\r\n                                  " + _vm._s(_vm._f("cents")(v.saldoVp)) + "\r\n                                  "), _c('span', {
        staticClass: "hide"
      }, [_vm._v(_vm._s(v.transferValue))]), _vm._v(" "), _c('span', {
        staticClass: "hide"
      }, [_vm._v(_vm._s(v.taxValue))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "dropdown drop-actions"
      }, [_c('button', {
        staticClass: "no-btn",
        attrs: {
          "id": "",
          "type": "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      }, [_c('img', {
        attrs: {
          "src": "/static/icon-actions.svg",
          "alt": ""
        }
      })]), _vm._v(" "), _c('ul', {
        staticClass: "dropdown-menu",
        attrs: {
          "aria-labelledby": ""
        }
      }, [(v.saldoVp > 0) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showRescue = true;
            _vm.rescueBalance(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-rescue"
      }), _vm._v("\r\n                                          Resgatar saldo VP\r\n                                        ")])]) : _vm._e(), _vm._v(" "), (v.tagSerialNumber) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'replace';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icon-sync"
      }), _vm._v("\r\n                                          Substituir TAG\r\n                                        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
        staticClass: "divider",
        attrs: {
          "role": "separator"
        }
      }), _vm._v(" "), _c('li', [(!_vm.showUnblock(v)) ? _c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'block';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-blocked"
      }), _vm._v("\r\n                                          Bloquear veículo\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(v)) ? _c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'unblock';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-blocked"
      }), _vm._v("\r\n                                          Desbloquear veículo\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'delete';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-delete"
      }), _vm._v("\r\n                                          Excluir veículo\r\n                                        ")])])])])])] : _vm._e()], 2)
    }), 0)]) : (_vm.loadingVehiclesAggregate) ? _c('p', [_vm._v("Carregando...")]) : (!_vm.aggregateVehicles && !_vm.loadingVehiclesAggregate) ? _c('div', {
      staticClass: "alert alert-warning alert-container margin-b20"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\r\n                            Nenhum veículo encontrado para o contrato.\r\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.aggregateVehicles) ? _c('div', {
      staticClass: "pagination-vp"
    }, [_c('p', {
      staticClass: "inline no-margin"
    }, [_vm._v("\r\n                            " + _vm._s(_vm.pageSm.firstIndexShown()) + "-" + _vm._s(_vm.pageSm.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSm.itemCount()) + " -\r\n                            "), _c('router-link', {
      staticClass: "bold",
      attrs: {
        "to": {
          name: 'aggregate-list',
          params: {
            contractId: c.contractId,
            fullResult: true
          }
        },
        "tag": "a"
      }
    }, [_vm._v("\r\n                              ver todos\r\n                              "), _c('img', {
      attrs: {
        "src": require("../../../static/ionic-ios-arrow-forward.svg"),
        "alt": ""
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "pull-right inline"
    }, [_c('pagination-sm', {
      attrs: {
        "model": _vm.pageSm
      },
      on: {
        "page-change": _vm.setCurrentPage
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex action-buttons margin-t10"
    }, [_c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Mais Detalhes do Plano\r\n                          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'aggregate-list',
          params: {
            contractId: c.contractId,
            moveMaisId: _vm.currentUser.moveMaisId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]), _vm._v(" "), _c('a', {
      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])])])], 2) : _c('accordion', {
      key: 'accordion' + n,
      staticClass: "margin-t20",
      attrs: {
        "open": n == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('contract-name', {
      attrs: {
        "contractId": c.contractId,
        "planId": c.plan.planId,
        "contractName": c.name,
        "currentBalance": c.currentBalance.currentTotalBalance
      },
      model: {
        value: (c.name),
        callback: function($$v) {
          _vm.$set(c, "name", $$v)
        },
        expression: "c.name"
      }
    })], 1), _vm._v(" "), _c('template', {
      slot: "content"
    }, [(c.dashType == 'EMBARCADOR-PRE') ? _c('div', {
      staticClass: "accordion-shipper"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "flex info"
    }, [_c('p', {
      staticClass: "no-margin inline"
    }, [_vm._v("\r\n                              Plano:\r\n                              "), _c('span', {
      staticClass: "bold upper"
    }, [_vm._v(_vm._s(c.dashType))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin inline"
    }, [_vm._v("\r\n                              Saldo disponível:\r\n                              "), _c('span', {
      staticClass: "bold upper",
      style: (c.currentBalance.currentBalance >= 0 ? 'color: #61A60E' : 'color: #FC4513')
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])])]), _vm._v(" "), _c('div', {
      staticClass: "flex between"
    }, [_c('router-link', {
      staticClass: "btn-tile credit",
      attrs: {
        "tag": "button",
        "to": {
          name: 'contract-recharge',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "data-toggle": "tooltip",
        "data-placement": "bottom"
      }
    }, [_vm._v("\r\n                              Comprar Crédito\r\n                              "), _c('i', {
      staticClass: "icon-share-money"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile route",
      attrs: {
        "tag": "button",
        "to": {
          name: 'routes'
        }
      }
    }, [_vm._v("\r\n                              Gestão de Rotas\r\n                              "), _c('i', {
      staticClass: "icon-route-chrono"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile toll",
      attrs: {
        "tag": "button",
        "to": {
          name: 'toll-ticket',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_vm._v("\r\n                              Vale-pedágio\r\n                              "), _c('i', {
      staticClass: "icon-toll-ticket"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile accomp",
      attrs: {
        "tag": "button",
        "to": {
          name: 'accompaniment',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_vm._v("\r\n                              Acompanhamento\r\n                              "), _c('i', {
      staticClass: "icon-truck-zoom"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile transfer",
      attrs: {
        "tag": "button",
        "to": {
          name: 'transfer-shipper',
          params: {
            contract: c
          }
        },
        "data-toggle": "tooltip",
        "data-placement": "bottom"
      }
    }, [_vm._v("\r\n                              Transferir Crédito\r\n                              "), _c('i', {
      staticClass: "icon-money-transfer"
    })])], 1), _vm._v(" "), (_vm.embarcadorVpPre && _vm.embarcadorVpPre.length > 0) ? _c('table', {
      staticClass: "table table-striped table-vp"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "30%"
      }
    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "14%"
      }
    }, [_vm._v("Data emissão")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "14%"
      }
    }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Valor VP")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "7%"
      }
    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.embarcadorVpPre), function(v, index) {
      return _c('tr', {
        key: index,
        class: {
          red: v.idProtocoloCanc != null
        }
      }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.transportador))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.dataEmissao)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
        staticClass: "bold text-center"
      }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "dropdown drop-actions"
      }, [_c('button', {
        staticClass: "no-btn",
        attrs: {
          "id": "",
          "type": "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      }, [_c('img', {
        attrs: {
          "src": "/static/icon-actions.svg",
          "alt": ""
        }
      })]), _vm._v(" "), _c('ul', {
        staticClass: "dropdown-menu",
        attrs: {
          "aria-labelledby": ""
        }
      }, [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showReceiptVp = true;
            _vm.modalReceiptVp(v.contractIdVp, v.idIntern)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": "/static/icon-eye.svg",
          "alt": "icon eye"
        }
      }), _vm._v("\r\n                                            Visualizar/Imprimir\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showRouteVp = true;
            _vm.modalRouteVp(v.contractIdVp, v.idIntern)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-truck-zoom_gray"
      }), _vm._v("\r\n                                            Rota do VP\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showPrintVp = true;
            _vm.modalPrintVp(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-file-export-gray"
      }), _vm._v("\r\n                                            Comprovante VP\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.cancelarVP(v.idIntern, v.placaVeiculo, 'pre')
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-close",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("\r\n                                              Cancelar VP\r\n                                            ")])])])])])] : _vm._e()], 2)
    }), 0)]) : _c('div', {
      staticClass: "alert alert-warning alert-container margin-b20"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\r\n                              Nenhum vale-pedágio encontrado para o contrato em questão.\r\n                            ")])]), _vm._v(" "), (_vm.embarcadorVpPre && _vm.embarcadorVpPre.length > 0) ? _c('div', {
      staticClass: "pagination-vp margin-b10"
    }, [_c('p', {
      staticClass: "inline no-margin"
    }, [_vm._v("\r\n                              " + _vm._s(_vm.pageSmVpPre.firstIndexShown()) + "-" + _vm._s(_vm.pageSmVpPre.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSmVpPre.itemCount()) + " -\r\n                              "), _c('router-link', {
      staticClass: "bold",
      attrs: {
        "to": {
          name: 'accompaniment',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "a"
      }
    }, [_vm._v("\r\n                                ver todos\r\n                                "), _c('img', {
      attrs: {
        "src": require("../../../static/ionic-ios-arrow-forward.svg"),
        "alt": ""
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "pull-right inline"
    }, [_c('pagination-sm', {
      attrs: {
        "model": _vm.pageSmVpPre
      },
      on: {
        "page-change": _vm.setCurrentPageVpPre
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex action-buttons"
    }, [_c('router-link', {
      staticClass: "btn-act",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                              Extrato\r\n                            ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'invoice-history',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                              Histórico de Contas\r\n                            ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                              Mais Detalhes do Plano \r\n                            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-POS') ? _c('div', {
      staticClass: "accordion-shipper"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "flex info"
    }, [_c('p', {
      staticClass: "no-margin inline"
    }, [_vm._v("\r\n                                Plano:\r\n                                "), _c('span', {
      staticClass: "bold upper"
    }, [_vm._v(_vm._s(c.dashType))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin inline"
    }, [_vm._v("\r\n                                Crédito:\r\n                                "), _c('span', {
      staticClass: "bold upper"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin inline"
    }, [_vm._v("\r\n                                Limite disponível:\r\n                                "), _c('span', {
      staticClass: "bold upper"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])])]), _vm._v(" "), _c('div', {
      staticClass: "flex between"
    }, [_c('router-link', {
      staticClass: "btn-tile route",
      attrs: {
        "tag": "button",
        "to": {
          name: 'routes'
        }
      }
    }, [_vm._v("\r\n                                Gestão de Rotas\r\n                                "), _c('i', {
      staticClass: "icon-route-chrono"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile toll",
      attrs: {
        "tag": "button",
        "to": {
          name: 'toll-ticket',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_vm._v("\r\n                                Vale-pedágio\r\n                                "), _c('i', {
      staticClass: "icon-toll-ticket"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile accomp",
      attrs: {
        "tag": "button",
        "to": {
          name: 'accompaniment',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_vm._v("\r\n                                Acompanhamento\r\n                                "), _c('i', {
      staticClass: "icon-truck-zoom"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-tile transfer",
      attrs: {
        "tag": "button",
        "to": {
          name: 'transfer-shipper',
          params: {
            contract: c
          }
        },
        "data-toggle": "tooltip",
        "data-placement": "bottom"
      }
    }, [_vm._v("\r\n                                Transferir Crédito\r\n                                "), _c('i', {
      staticClass: "icon-money-transfer"
    })])], 1), _vm._v(" "), (_vm.embarcadorVpPos && _vm.embarcadorVpPos.length > 0) ? _c('table', {
      staticClass: "table table-striped table-vp"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "38%"
      }
    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Data emissão")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Valor VP")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      attrs: {
        "width": "7%"
      }
    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.embarcadorVpPos), function(v, index) {
      return _c('tr', {
        key: index,
        class: {
          red: v.idProtocoloCanc != null
        }
      }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                      " + _vm._s(v.transportador) + "\r\n                                      "), (v.idProtocoloCanc != null) ? _c('span', [_vm._v(" (Cancelado)")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.dataEmissao)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
        staticClass: "bold text-center"
      }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "dropdown drop-actions"
      }, [_c('button', {
        staticClass: "no-btn",
        attrs: {
          "id": "",
          "type": "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      }, [_c('img', {
        attrs: {
          "src": "/static/icon-actions.svg",
          "alt": ""
        }
      })]), _vm._v(" "), _c('ul', {
        staticClass: "dropdown-menu",
        attrs: {
          "aria-labelledby": ""
        }
      }, [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showReceiptVp = true;
            _vm.modalReceiptVp(v.contractIdVp, v.idIntern)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": "/static/icon-eye.svg",
          "alt": "icon eye"
        }
      }), _vm._v("\r\n                                              Visualizar/Imprimir\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showRouteVp = true;
            _vm.modalRouteVp(v.contractIdVp, v.idIntern)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-truck-zoom_gray"
      }), _vm._v("\r\n                                              Rota do VP\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showPrintVp = true;
            _vm.modalPrintVp(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-file-export-gray"
      }), _vm._v("\r\n                                              Comprovante VP\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.cancelarVP(v.idIntern, v.placaVeiculo, 'pos')
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-close",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("\r\n                                              Cancelar VP\r\n                                            ")])])])])])] : _vm._e()], 2)
    }), 0)]) : _c('div', {
      staticClass: "alert alert-warning alert-container margin-b20"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\r\n                                Nenhum vale-pedágio encontrado para o contrato em questão.\r\n                              ")])]), _vm._v(" "), (_vm.embarcadorVpPos && _vm.embarcadorVpPos.length > 0) ? _c('div', {
      staticClass: "pagination-vp margin-b10"
    }, [_c('p', {
      staticClass: "inline no-margin"
    }, [_vm._v("\r\n                                " + _vm._s(_vm.pageSmVpPos.firstIndexShown()) + "-" + _vm._s(_vm.pageSmVpPos.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSmVpPos.itemCount()) + " -\r\n                                "), _c('router-link', {
      staticClass: "bold",
      attrs: {
        "to": {
          name: 'accompaniment',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "a"
      }
    }, [_vm._v("\r\n                                  ver todos\r\n                                  "), _c('img', {
      attrs: {
        "src": require("../../../static/ionic-ios-arrow-forward.svg"),
        "alt": ""
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "pull-right inline"
    }, [_c('pagination-sm', {
      attrs: {
        "model": _vm.pageSmVpPos
      },
      on: {
        "page-change": _vm.setCurrentPageVpPos
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex action-buttons"
    }, [_c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                                Extrato\r\n                              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'invoice-history',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                                Histórico de Contas\r\n                              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                                Mais Detalhes do Plano \r\n                              ")])], 1)])])]) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_AUTO' || c.plan.planId == 62 || c.plan.planId == 64) ? _c('div', {
      staticClass: "row pre"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Saldo:\r\n                            "), _c('b', {
      staticClass: "pull-right",
      class: c.currentBalance.currentBalance >= 0 ? 'green' : 'red'
    }, [_vm._v(_vm._s(_vm.getCurrentBalance(c)))])]), _vm._v(" "), _c('div', {
      staticClass: "btn-group-accordion"
    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn btn-success padding-10",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "to": {
          name: 'contract-recharge',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button",
        "disabled": !_vm.checkVehicle
      }
    }, [_vm._v("\r\n                              Recarga extra\r\n                            ")]) : _c('button', {
      staticClass: "btn btn-success padding-10",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle || c.status.contractStatusId != 1 || c.status.contractStatusId != 5
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_vm._v("\r\n                              Recarga extra\r\n                            ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn btn-purple",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "tag": "button",
        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 || !_vm.checkVehicle,
        "to": {
          name: 'transfer-credit',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        }
      }
    }, [_vm._v("\r\n                              Transferir Saldo\r\n                              "), _c('i', {
      staticClass: "icon-money-transfer"
    })]) : _c('button', {
      staticClass: "btn btn-purple",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_vm._v("\r\n                                  Transferir Saldo\r\n                                  "), _c('i', {
      staticClass: "icon-money-transfer"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "box-btn-recharge bar"
    }, [_c('p', {
      class: 'limit-percent-' + _vm.getPercentRechargeAut(c.plan.planId)
    }, [_vm._v("\r\n                              " + _vm._s(_vm.getPercentRechargeAut(c.plan.planId)) + "%\r\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "progress progress-recharge"
    }, [_c('div', {
      staticClass: "progress-bar",
      class: _vm.getRechargeClass(c),
      style: (_vm.getRechargeStyle(c)),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": _vm.getRechargePercent(c),
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "data-placement": "top",
        "data-toggle": "tooltip",
        "title": _vm.getRechargePercent(c) + '%'
      }
    }), _vm._v(" "), _c('div', {
      class: 'limit-' + _vm.getPercentRechargeAut(c.plan.planId)
    })]), _vm._v(" "), _c('p', {
      staticClass: "txt-rec-auto no-margin",
      on: {
        "click": function($event) {
          return _vm.openModalRecharge(c.contractId)
        }
      }
    }, [_c('b', {
      staticClass: "pull-right force-link",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Editar o valor da recarga automática"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm._f("cents")(_vm.getAutomaticRechargeValue(c))) + "\r\n                                "), _c('i', {
      staticClass: "icon-pencil icon-edit"
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
      staticClass: "plan-status",
      attrs: {
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-tooltip-style": "orange-tooltip",
        "title": _vm.getTooltipText(c)
      }
    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
      class: _vm.getStatusClass(c),
      attrs: {
        "tag": "a",
        "to": {
          name: 'reprocess-orders',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "blockedContract"
      }
    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
      staticStyle: {
        "display": "inline-flex",
        "align-items": "center",
        "gap": "5px"
      }
    }, [(c.isEntryBlocked === 999) ? _c('img', {
      staticClass: "has-click",
      attrs: {
        "src": require("../../assets/img/icons/icon-blocked-entry.svg")
      },
      on: {
        "click": function($event) {
          return _vm.showMessage()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.getStatusClass(c),
      attrs: {
        "id": "statusContract"
      }
    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "status-pull"
    }, [_c('span', {
      class: _vm.getStatusDotsClass(c)
    })])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
      staticClass: "plan-name-label"
    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-default-plan",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Mais Detalhes do Plano \r\n                          ")])], 1)]), _vm._v(" "), (c.summary) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.cadastrados))])]), _vm._v(" "), _c('div', {}, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn-default-plan",
      attrs: {
        "to": {
          name: 'contract-vehicles',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                              Ver veículos\r\n                            ")]) : _c('button', {
      staticClass: "btn-default-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_vm._v("\r\n                                Ver veículos\r\n                              ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "flex action-buttons margin-t20"
    }, [_c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "type": "button",
        "disabled": _vm.loadingPaymentMethods[c.contractId]
      },
      on: {
        "click": function($event) {
          return _vm.openPaymentMethods(c.contractId)
        }
      }
    }, [(_vm.loadingPaymentMethods[c.contractId]) ? _c('span', {
      staticClass: "loading-spinner"
    }) : _c('span', [_vm._v("Formas de Pagamento")])]), _vm._v(" "), (c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36) ? _c('button', {
      staticClass: "btn-act button-icomoon disabled",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]) : _c('button', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showModalTransfer()
        }
      }
    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]), _vm._v(" "), _c('a', {
      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)]), _vm._v(" "), (c.plan.planId == 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-automatic', {
      attrs: {
        "contract": c
      },
      on: {
        "closeModalRecharge": _vm.closeModalRecharge
      }
    }) : _vm._e(), _vm._v(" "), (c.plan.planId != 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-recharge', {
      attrs: {
        "contract": c
      },
      on: {
        "closeModalRecharge": _vm.closeModalRecharge
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_MAN') ? _c('div', {
      staticClass: "row pre mn"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Saldo:\r\n                            "), _c('b', {
      staticClass: "pull-right",
      class: c.currentBalance.currentBalance > 0 ? 'green' : 'red'
    }, [_vm._v(_vm._s(_vm.getCurrentBalance(c)))])]), _vm._v(" "), _c('div', {
      staticClass: "btn-group-accordion"
    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn btn-success",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "to": {
          name: 'contract-recharge',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button",
        "disabled": !_vm.checkVehicle
      }
    }, [_vm._v("\r\n                              Recarregar\r\n                              "), _c('i', {
      staticClass: "icon-recharge"
    })]) : _c('button', {
      staticClass: "btn btn-success",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle || c.status.contractStatusId != 1 || c.status.contractStatusId != 5
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_vm._v("\r\n                              Recarregar\r\n                              "), _c('i', {
      staticClass: "icon-recharge"
    })]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn btn-purple",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "tag": "button",
        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 && c.plan.planId != 70 && c.plan.planId != 71 || !_vm.checkVehicle,
        "to": {
          name: 'transfer-credit',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        }
      }
    }, [_vm._v("\r\n                              Transferir Saldo\r\n                              "), _c('i', {
      staticClass: "icon-money-transfer"
    })]) : _c('button', {
      staticClass: "btn btn-purple",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_vm._v("\r\n                                  Transferir Saldo\r\n                                  "), _c('i', {
      staticClass: "icon-money-transfer"
    })])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
      staticClass: "plan-status",
      attrs: {
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-tooltip-style": "orange-tooltip",
        "title": _vm.getTooltipText(c)
      }
    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
      class: _vm.getStatusClass(c),
      attrs: {
        "tag": "a",
        "to": {
          name: 'reprocess-orders',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "blockedContract"
      }
    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
      staticStyle: {
        "display": "inline-flex",
        "align-items": "center",
        "gap": "5px"
      }
    }, [(c.isEntryBlocked === 999) ? _c('img', {
      staticClass: "has-click",
      attrs: {
        "src": require("../../assets/img/icons/icon-blocked-entry.svg")
      },
      on: {
        "click": function($event) {
          return _vm.showMessage()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.getStatusClass(c),
      attrs: {
        "id": "statusContract"
      }
    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "status-pull"
    }, [_c('span', {
      class: _vm.getStatusDotsClass(c)
    })])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
      staticClass: "plan-name-label"
    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])])])]), _vm._v(" "), (c.summary) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.cadastrados))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "flex action-buttons margin-t20"
    }, [_c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "type": "button",
        "disabled": _vm.loadingPaymentMethods[c.contractId]
      },
      on: {
        "click": function($event) {
          return _vm.openPaymentMethods(c.contractId)
        }
      }
    }, [(_vm.loadingPaymentMethods[c.contractId]) ? _c('span', {
      staticClass: "loading-spinner"
    }) : _c('span', [_vm._v("Formas de Pagamento")])]), _vm._v(" "), (c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36) ? _c('button', {
      staticClass: "btn-act button-icomoon disabled",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]) : _c('button', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showModalTransfer()
        }
      }
    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-default-plan button-icomoon",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Mais Detalhes do Plano\r\n                          ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && _vm.checkVehicle) ? _c('router-link', {
      staticClass: "btn-default-plan button-icomoon",
      attrs: {
        "disabled": _vm.bloqueiaRoadcard,
        "to": {
          name: 'contract-vehicles',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])]) : _vm._e(), _vm._v(" "), (c.dashType == 'POS_PAGO') ? _c('div', {
      staticClass: "row pre mn",
      class: {
        'has-tag-reserva': _vm.possuiTagReserva
      }
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Limite de Crédito:\r\n                            "), _c('b', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.creditLimit)))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Limite Disponível:\r\n                            "), _c('b', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Dias de Vencimento:\r\n                            "), _c('b', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm.getBillingDates(c)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
      staticClass: "plan-status",
      attrs: {
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-tooltip-style": "orange-tooltip",
        "title": _vm.getTooltipText(c)
      }
    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
      class: _vm.getStatusClass(c),
      attrs: {
        "tag": "a",
        "to": {
          name: 'reprocess-orders',
          params: {
            contractId: c.contractId
          }
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "blockedContract"
      }
    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
      staticStyle: {
        "display": "inline-flex",
        "align-items": "center",
        "gap": "5px"
      }
    }, [(c.isEntryBlocked === 999) ? _c('img', {
      staticClass: "has-click",
      attrs: {
        "src": require("../../assets/img/icons/icon-blocked-entry.svg")
      },
      on: {
        "click": function($event) {
          return _vm.showMessage()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.getStatusClass(c),
      attrs: {
        "id": "statusContract"
      }
    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "status-pull"
    }, [_c('span', {
      class: _vm.getStatusDotsClass(c)
    })])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
      staticClass: "plan-name-label"
    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])]), _vm._v(" "), (_vm.possuiTagReserva) ? _c('p', {
      staticClass: "no-margin accordion-pad",
      staticStyle: {
        "clear": "both"
      }
    }, [_vm._v("\r\n                            Qtd. TAG reserva disponíveis:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(_vm.tagReservaSaldoByContract[c.contractId] != null ? _vm.tagReservaSaldoByContract[c.contractId] : 0))])]) : _vm._e()])]), _vm._v(" "), (c.summary) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "col-accordion"
    }, [_c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
      staticClass: "no-margin accordion-pad"
    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
      staticClass: "pull-right purple"
    }, [_vm._v(_vm._s(c.summary.cadastrados))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "flex action-buttons margin-t20"
    }, [_c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-act button-icomoon",
      attrs: {
        "to": {
          name: 'invoice-history',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Histórico de Contas\r\n                          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-default-plan button-icomoon",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Mais Detalhes do Plano \r\n                          ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn-default-plan button-icomoon",
      attrs: {
        "to": {
          name: 'contract-vehicles',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])]) : _vm._e()])], 2)] : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.showModalMyContracts) ? _c('div', [_c('modal-my-contracts', {
    on: {
      "close": function($event) {
        return _vm.fecharModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-new"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.svgContent) ? _c('div', {
    staticClass: "zapay-banner",
    on: {
      "click": function($event) {
        return _vm.onPartnerBannerClick('web')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "object-fit": "cover"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svgContent)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 plan-mobile hidden-print"
  }, [(_vm.vp) ? _c('accordion', {
    staticClass: "margin-t20 vp-accordion",
    attrs: {
      "open": true
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('span', {
    staticClass: "upper bold"
  }, [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-striped table-vp"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Emissor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Expiração")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vp), function(v, index) {
    return _c('tr', {
      key: index,
      class: {
        red: v.idProtocoloCanc != null
      }
    }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.embarcador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-center"
    }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("centsNoSymbol")(v.valorVP)))])] : _vm._e()], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex action-buttons margin-t10"
  }, [_c('router-link', {
    staticClass: "btn-act",
    attrs: {
      "to": {
        name: 'my-toll-ticket',
        params: {
          contractId: _vm.vp[0].contratoDest,
          planId: 7
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\r\n                        Ver Todos Vales-pedágio\r\n                      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-act",
    attrs: {
      "to": {
        name: 'statement-consolidated',
        params: {
          contractId: _vm.vp[0].contratoDest
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\r\n                        Saldo & Extrato\r\n                      ")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.state == 'LOADED') ? _c('div', {}, _vm._l((_vm.contracts), function(c, n) {
    return (c.plan.planId != 7 && c.plan.planId != 45 && c.plan.planId != 46) ? _c('div', {
      key: n,
      staticClass: "plan-box"
    }, [_c('div', {}, [_c('h5', {
      staticClass: "three-dots"
    }, [_vm._v(_vm._s(c.plan.name))]), _vm._v(" "), _c('p', {
      staticClass: "gray"
    }, [_vm._v("Saldo disponível")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))]), _vm._v(" "), (c.currentBalance.creditLimit) ? _c('p', {
      staticClass: "bold-600 gray"
    }, [_vm._v("\r\n                  Crédito:\r\n                  "), _c('span', {
      staticClass: "blue"
    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.creditLimit)))])]) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('div', {
      staticClass: "box-btn-recharge bar"
    }, [_c('p', {
      class: 'limit-percent-' + _vm.getPercentRechargeAut(c.plan.planId)
    }, [_vm._v("\r\n                    " + _vm._s(_vm.getPercentRechargeAut(c.plan.planId)) + "%\r\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "progress progress-recharge"
    }, [_c('div', {
      staticClass: "progress-bar",
      class: _vm.getRechargeClass(c),
      style: (_vm.getRechargeStyle(c)),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": _vm.getRechargePercent(c),
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "data-placement": "top",
        "data-toggle": "tooltip",
        "title": _vm.getRechargePercent(c) + '%'
      }
    }), _vm._v(" "), _c('div', {
      class: 'limit-' + _vm.getPercentRechargeAut(c.plan.planId)
    })]), _vm._v(" "), _c('p', {
      staticClass: "txt-rec-auto no-margin",
      on: {
        "click": function($event) {
          return _vm.openModalRecharge(c.contractId)
        }
      }
    }, [_c('b', {
      staticClass: "pull-right force-link",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Editar o valor da recarga automática"
      }
    }, [_vm._v("\r\n                    " + _vm._s(_vm._f("cents")(_vm.getAutomaticRechargeValue(c))) + "\r\n                    "), _c('i', {
      staticClass: "icon-pencil icon-edit"
    })])])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "bold-600 margin-t10"
    }, [(c.name) ? _c('span', [_vm._v(_vm._s(c.name))]) : _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', {
      staticClass: "partial-blocked-text",
      attrs: {
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-tooltip-style": "orange-tooltip",
        "title": _vm.getTooltipText(c)
      }
    }, [(c.isEntryBlocked === 999) ? _c('img', {
      staticClass: "has-click",
      attrs: {
        "src": require("../../assets/img/icons/icon-blocked-entry.svg")
      },
      on: {
        "click": function($event) {
          return _vm.showMessage()
        }
      }
    }) : _vm._e(), _vm._v("\r\n                  " + _vm._s(_vm.getMobileStatusName(c)) + "\r\n                  "), _c('span', {
      class: _vm.getStatusDotsClass(c)
    })])]), _vm._v(" "), _c('p', {
      staticClass: "purple"
    }, [_vm._v("\r\n                N° Contrato: " + _vm._s(c.contractId) + "\r\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("date")(c.createdDate)))])]), _vm._v(" "), _c('button', {
      staticClass: "no-btn",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          c.open = !c.open
        }
      }
    }, [_c('i', {
      staticClass: "icon-arrow-major",
      class: c.open ? 'open' : ''
    })])]), _vm._v(" "), _c('div', {
      staticClass: "expand-plan",
      class: c.open ? 'open' : ''
    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('router-link', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "to": {
          name: 'contract-recharge',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button",
        "disabled": !_vm.checkVehicle
      }
    }, [_c('i', {
      staticClass: "icomoon-money"
    }), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('span', [_vm._v("\r\n                   Recarga"), _c('br'), _vm._v("extra\r\n                ")]) : _c('span', [_vm._v("\r\n                  Fazer"), _c('br'), _vm._v("recarga\r\n                ")])]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-money"
    }), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('span', [_vm._v("\r\n                   Recarga"), _c('br'), _vm._v("extra\r\n                ")]) : _c('span', [_vm._v("\r\n                  Fazer"), _c('br'), _vm._v("recarga\r\n                ")])]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE') ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'buy-credit'
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icon-add-vehicle"
    }), _vm._v("\r\n                Comprar"), _c('br'), _vm._v("crédito\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-invoice"
    }), _vm._v("\r\n                Extrato"), _c('br'), _vm._v("detalhado\r\n              ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('router-link', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "tag": "button",
        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 || !_vm.checkVehicle,
        "to": {
          name: 'transfer-credit',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-money-transfer"
    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_c('i', {
      staticClass: "icon-money-transfer"
    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_AUTO' || c.dashType == 'PRE_MAN')) ? _c('button', {
      staticClass: "btn-card-plan",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openPaymentMethods(c.contractId)
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-payment-method"
    }), _vm._v("\r\n                Formas de"), _c('br'), _vm._v("Pagamento\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_AUTO' || c.dashType == 'PRE_MAN')) ? _c('button', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-payment-method"
    }), _vm._v("\r\n                Formas de"), _c('br'), _vm._v("Pagamento\r\n              ")]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'routes'
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-route-management"
    }), _vm._v("\r\n                Gestão"), _c('br'), _vm._v("de rotas\r\n              ")]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'toll-ticket',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-toll-order"
    }), _vm._v("\r\n                Emitir"), _c('br'), _vm._v("Vale-pedágio\r\n              ")]) : _vm._e(), _vm._v(" "), (c.plan.planId == 6 || c.plan.planId == 8) ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'accompaniment',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-truck-zoom"
    }), _vm._v("\r\n                Acompa-"), _c('br'), _vm._v("nhamento\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-vehicles',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-vehicle' : 'icomoon-truck'
    }), _vm._v("Veículos"), _c('br'), _vm._v("cadastrados\r\n              ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-vehicles-new',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-add-vehicle' : 'icomoon-truck-add'
    }), _vm._v("\r\n                Adicionar"), _c('br'), _vm._v("veículos\r\n              ")]) : _c('button', {
      staticClass: "btn-card-plan",
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_c('i', {
      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-add-vehicle' : 'icomoon-truck-add'
    }), _vm._v("\r\n                Adicionar"), _c('br'), _vm._v("veículos\r\n              ")]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-plan-detail"
    }), _vm._v("\r\n                Mais detalhes"), _c('br'), _vm._v("do plano \r\n              ")]), _vm._v(" "), (c.plan.planId !== 21 && c.plan.planId !== 22) ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'invoice-history',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-count-history"
    }), _vm._v("\r\n                Histórico"), _c('br'), _vm._v("de contas\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle
      },
      attrs: {
        "disabled": !_vm.checkVehicle
      },
      on: {
        "click": function($event) {
          return _vm.showMessageContract()
        }
      }
    }, [_c('i', {
      staticClass: "icon-money-transfer"
    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      class: {
        'disabled': !_vm.checkVehicle || _vm.checkMigration == 1
      },
      attrs: {
        "to": _vm.hasRodosol ? {
          name: 'migration-plan',
          params: {
            rodosol: _vm.hasRodosol,
            contract: _vm.contractSelected
          }
        } : {
          name: 'new-contract'
        },
        "tag": "button",
        "disabled": !_vm.checkVehicle || _vm.checkMigration == 1
      }
    }, [_c('i', {
      class: _vm.hasRodosol ? 'new-icon-migrate-plan' : 'icomoon-new-plan'
    }, [_c('span', {
      staticClass: "path1"
    }), _c('span', {
      staticClass: "path2"
    }), _c('span', {
      staticClass: "path3"
    }), _c('span', {
      staticClass: "path4"
    })]), _vm._v(" "), (_vm.hasRodosol) ? _c('span', {
      staticStyle: {
        "margin-top": "1rem"
      }
    }, [_vm._v("\r\n                  Migrar"), _c('br'), _vm._v("de plano\r\n                ")]) : _c('span', [_vm._v("\r\n                  Novo"), _c('br'), _vm._v("plano\r\n                ")])]), _vm._v(" "), _c('button', {
      staticClass: "btn-card-plan btn-zapay-mobile",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.openMyContractsModal
      }
    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true)]), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'transfer-shipper',
          params: {
            contract: c
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-money-transfer"
    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("crédito\r\n              ")]) : _vm._e()], 1), _vm._v(" "), ((c.plan.planId == 21 || c.plan.planId == 22 || c.plan.planId == 35 || c.plan.planId == 36) && _vm.checkVehicle) ? _c('modal-transfer', {
      key: 'modal-transfer' + n
    }) : _vm._e(), _vm._v(" "), (c.plan.planId == 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-automatic', {
      attrs: {
        "contract": c
      },
      on: {
        "closeModalRecharge": _vm.closeModalRecharge
      }
    }) : _vm._e(), _vm._v(" "), (c.plan.planId != 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-recharge', {
      attrs: {
        "contract": c
      },
      on: {
        "closeModalRecharge": _vm.closeModalRecharge
      }
    }) : _vm._e()], 1) : (c.plan.planId == 45 || c.plan.planId == 46) ? _c('div', {
      staticClass: "plan-box"
    }, [_c('div', {}, [_c('h5', {
      staticClass: "three-dots"
    }, [_vm._v(_vm._s(c.plan.name))]), _vm._v(" "), _c('p', {
      staticClass: "gray"
    }, [_vm._v("Saldo disponível")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))]), _vm._v(" "), _c('p', {
      staticClass: "bold-600 margin-t10"
    }, [(c.name) ? _c('span', [_vm._v(_vm._s(c.name))]) : _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', {
      staticClass: "partial-blocked-text",
      attrs: {
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-tooltip-style": "orange-tooltip",
        "title": _vm.getTooltipText(c)
      }
    }, [(c.isEntryBlocked === 999) ? _c('img', {
      staticClass: "has-click",
      attrs: {
        "src": require("../../assets/img/icons/icon-blocked-entry.svg")
      },
      on: {
        "click": function($event) {
          return _vm.showMessage()
        }
      }
    }) : _vm._e(), _vm._v("\r\n                  " + _vm._s(_vm.getMobileStatusName(c)) + "\r\n                  "), _c('span', {
      class: _vm.getStatusDotsClass(c)
    })])]), _vm._v(" "), _c('p', {
      staticClass: "purple"
    }, [_vm._v("\r\n                N° Contrato: " + _vm._s(c.contractId) + "\r\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("date")(c.createdDate)))])]), _vm._v(" "), _c('button', {
      staticClass: "no-btn",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          c.open = !c.open
        }
      }
    }, [_c('i', {
      staticClass: "icon-arrow-major",
      class: c.open ? 'open' : ''
    })])]), _vm._v(" "), _c('div', {
      staticClass: "expand-plan",
      class: c.open ? 'open' : ''
    }, [_c('button', {
      staticClass: "btn-card-plan",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modalAggregate(c)
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-truck-add"
    }), _vm._v("\r\n                Novo"), _c('br'), _vm._v("agregador\r\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-card-plan",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modalTollTicket()
        }
      }
    }, [_c('i', {
      staticClass: "icomoon-toll-order"
    }), _vm._v("\r\n                Emitir"), _c('br'), _vm._v("Vale-pedágio\r\n              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'rescue-balance',
          params: {
            contractId: c.contractId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-rescue"
    }), _vm._v("\r\n                Resgatar"), _c('br'), _vm._v("Saldo\r\n              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-statement',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-invoice"
    }), _vm._v("\r\n                Extrato"), _c('br'), _vm._v("detalhado\r\n              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'aggregate-list',
          params: {
            contractId: c.contractId,
            contract: c,
            moveMaisId: _vm.currentUser.moveMaisId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-truck"
    }), _vm._v("\r\n                Veículos"), _c('br'), _vm._v("cadastrados\r\n              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'contract-detail',
          params: {
            contractId: c.contractId,
            planId: c.plan.planId
          }
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-plan-detail"
    }), _vm._v("\r\n                Mais detalhes"), _c('br'), _vm._v("do plano\r\n              ")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-card-plan",
      attrs: {
        "to": {
          name: 'new-contract'
        },
        "tag": "button"
      }
    }, [_c('i', {
      staticClass: "icomoon-new-plan"
    }, [_c('span', {
      staticClass: "path1"
    }), _c('span', {
      staticClass: "path2"
    }), _c('span', {
      staticClass: "path3"
    }), _c('span', {
      staticClass: "path4"
    })]), _vm._v("\r\n                Novo"), _c('br'), _vm._v("plano\r\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.aggregateVehicles), function(v, index) {
      return (index < 6) ? _c('li', {
        key: index,
        class: {
          red: v.idProtocoloCanc != null
        }
      }, [_c('p', [_vm._v("\r\n                    N° da placa\r\n                    "), _c('span', {
        staticClass: "pull-right"
      }, [_c('button', {
        staticClass: "no-btn",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            v.open = !v.open
          }
        }
      }, [_c('i', {
        staticClass: "icon-arrow-major",
        class: v.open ? 'open' : ''
      })])]), _vm._v(" "), _c('span', {
        directives: [{
          name: "mask-plate",
          rawName: "v-mask-plate"
        }],
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(v.plate))])]), _vm._v(" "), _c('div', {
        staticClass: "expand-agg",
        class: v.open ? 'open' : ''
      }, [_c('p', [_vm._v("\r\n                      Status\r\n                      "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(" ")]), _vm._v(" "), (v.reason == 'Desbloqueado') ? _c('i', {
        staticClass: "icomoon-truck-ok pull-right"
      }) : (v.reason == 'Temporariamente') ? _c('i', {
        staticClass: "icomoon-truck-block pull-right"
      }) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Transportador\r\n                      "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(v.transportador))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Último VP\r\n                      "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(_vm._f("date")(v.lastVp)))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Última passagem\r\n                      "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(_vm._f("date")(v.lastPassage)))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Saldo VP\r\n                      "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v(_vm._s(_vm._f("cents")(v.saldoVp)))])]), _vm._v(" "), _c('span', [_vm._v("\r\n                      Ações\r\n                      "), _c('div', {
        staticClass: "dropdown drop-actions pull-right"
      }, [_vm._m(7, true), _vm._v(" "), _c('ul', {
        staticClass: "dropdown-menu",
        attrs: {
          "aria-labelledby": ""
        }
      }, [(v.saldoVp > 0) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.showRescue = true;
            _vm.rescueBalance(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-rescue"
      }), _vm._v("\r\n                              Resgatar saldo VP\r\n                            ")])]) : _vm._e(), _vm._v(" "), _c('li', {
        staticClass: "divider",
        attrs: {
          "role": "separator"
        }
      }), _vm._v(" "), _c('li', [(!_vm.showUnblock(v)) ? _c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'block';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-blocked"
      }), _vm._v("\r\n                              Bloquear veículo\r\n                            ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(v)) ? _c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'unblock';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-blocked"
      }), _vm._v("\r\n                              Desbloquear veículo\r\n                            ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.typeAggregate = 'delete';
            _vm.modalBlock(v)
          }
        }
      }, [_c('i', {
        staticClass: "icomoon-delete"
      }), _vm._v("\r\n                              Excluir veículo\r\n                            ")])])])])])])]) : _vm._e()
    }), 0)], 1)]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.svgContentMobile) ? _c('div', {
    staticClass: "zapay-banner",
    on: {
      "click": function($event) {
        return _vm.onPartnerBannerClick('mobile')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "object-fit": "cover"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svgContentMobile)
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.showModalAggregate) ? _c('modal-aggregate', {
    attrs: {
      "contractAggregate": _vm.contractAggregate
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalTollTicket) ? _c('modal-toll-ticket', {
    attrs: {
      "contractShipper": _vm.contractShipper
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRescue) ? _c('modal-rescue-balance', {
    attrs: {
      "rescueData": _vm.rescueData
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrintVp) ? _c('modal-print-vp', {
    attrs: {
      "vpSelected": _vm.vpSelected
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBlock) ? _c('modal-block-vehicle', {
    attrs: {
      "v": _vm.v,
      "vpSelected": _vm.vpSelected,
      "type": _vm.typeAggregate
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRouteVp) ? _c('modal-route-vp', {
    attrs: {
      "vpData": _vm.vpData
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showReceiptVp) ? _c('modal-receipt-vp', {
    attrs: {
      "vpData": _vm.vpData
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalMyContracts) ? _c('div', [_c('modal-my-contracts', {
    on: {
      "close": function($event) {
        return _vm.fecharModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-new"
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-info-block",
    attrs: {
      "tabindex": "-2",
      "role": "dialog",
      "id": "info-block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/exclamation-mark.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Lembrando que para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar seu(s) TAG(s).")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close valor-debitado-titulo",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-merc-text"
  }, [_c('span', [_vm._v("novo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-button"
  }, [_c('span', {
    staticClass: "font-button"
  }, [_vm._v("Mudar placa para padrão Mercosul "), _c('img', {
    staticClass: "repeat-icon",
    attrs: {
      "src": require("../../assets/img/icons/repeat.svg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn-card-plan btn-debitos-veiculares-mobile",
    attrs: {
      "href": "https://www.zignet.com.br/parceiro/movemais-interno",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "new-feature"
  }, [_c('span', [_vm._v("novo")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/icons/car-coin.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0",
      "line-height": "12px"
    }
  }, [_vm._v("Parcelamento"), _c('br'), _vm._v("de multas e débitos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-zapay-new"
  }, [_c('span', [_vm._v("novo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merc-container"
  }, [_c('img', {
    staticClass: "repeat-icon",
    attrs: {
      "src": require("../../assets/img/icons/repeat.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "9px",
      "text-align": "center",
      "margin-top": "3px"
    }
  }, [_vm._v("\r\n                  Padrão Mercosul\r\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "no-btn",
    attrs: {
      "id": "",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icon-actions.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-c8bebda2!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/plans.vue
// module id = 2213
// module chunks = 1